import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as dayjs from 'dayjs';
import * as calendar from 'dayjs/plugin/calendar';
import * as relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(calendar);
dayjs.extend(relativeTime);

@Pipe({
  name: 'milisecondsToDateString',
  standalone: false,
})
export class milisecondsToDateStringPipe extends DatePipe implements PipeTransform {
  public transform(value: any, formatArg: string): any {
    const date = new Date(0);
    date.setUTCSeconds(value);

    if (formatArg === 'calendar') {
      return dayjs(date).startOf('day').calendar();
    } else if (formatArg === 'fromNow') {
      return dayjs(date).startOf('day').fromNow();
    }

    let format = 'MM/DD/YYYY';
    if (formatArg) {
      format = formatArg;
    }
    return dayjs(date).format(format);
  }
}
